import { TRPCClientError } from "@trpc/client";
import { TRPCFetchError } from "./TRPCFetchError";

/**
 * Checks if an error is a connection/network error that should be retried.
 * This includes:
 * - TRPCFetchError (wraps "Failed to fetch" and other network errors)
 * - TRPCClientError caused by a TRPCFetchError
 */
export function isConnectionError(error: unknown): boolean {
  if (error instanceof TRPCFetchError) {
    return true;
  }

  if (error instanceof TRPCClientError) {
    // Check if the cause is a TRPCFetchError
    if (error.cause instanceof TRPCFetchError) {
      return true;
    }

    // Also check for TypeError: Failed to fetch which might not be wrapped
    if (
      error.cause instanceof TypeError &&
      error.cause.message === "Failed to fetch"
    ) {
      return true;
    }
  }

  return false;
}
